"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fmoney_1 = require("./fmoney");
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoneyspace(value, forcezeros, precision) {
    if (precision === void 0) { precision = 2; }
    var ext = fmoney_1.default(value, forcezeros, precision);
    var parts = ext.split(',');
    var result = '';
    var l = parts[0].length - 1;
    for (var i = 0; i <= l; i++) {
        result = parts[0][l - i] + result;
        if (i < l && (i === 2 || i === 5 || i === 8 || i === 11)) {
            result = ' ' + result;
        }
    }
    if (parts.length > 1) {
        return result + ',' + parts[1];
    }
    else {
        return result;
    }
}
exports.default = fmoneyspace;
//# sourceMappingURL=fmoneyspace.js.map